/* Product Finder v3 (Aug 2026): path-aware progress, accessible transitions,
   availability pre-flight, and a transparent results handoff. */
(function () {
  var root = document.getElementById('pf2');
  if (!root) return;
  if (!window.CS_LEVELS) return setTimeout(arguments.callee, 80);

  var state = { base: '/collections/all', level: 1, gender: null, style: null, toe: null, conditionPath: false, relaxed: [] };
  var recLevel = 1;
  var crumbs = []; /* [{step, label}] */
  var steps = Array.prototype.slice.call(root.querySelectorAll('.pf2-step'));
  var current = 0, availToken = 0;
  var countCache = {};

  function escapeHtml(value) {
    var el = document.createElement('span');
    el.textContent = value == null ? '' : String(value);
    return el.innerHTML;
  }

  /* ---------- availability ---------- */
  function countFor(url) {
    if (countCache[url] !== undefined) return Promise.resolve(countCache[url]);
    var u = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'section_id=pf-count';
    return fetch(u).then(function (r) { return r.text(); }).then(function (t) {
      var m = t.match(/pfc:\s*(\d+)/);
      var n = m ? parseInt(m[1], 10) : -1; /* -1 = unknown, treat as available */
      countCache[url] = n; return n;
    }).catch(function () { return -1; });
  }
  /* Shopify quirk: a facet VALUE with zero matches in the current collection, when sent
     alongside a valid value, can zero out the whole result (order-dependent). So we probe
     once per base whether Unisex exists there and only then pair it with the picked gender. */
  function probeUnisex() {
    state.unisexOk = true;
    if (state.base === '/collections/all') return;
    countFor(state.base + '?filter.p.m.custom.filter_gender=Unisex').then(function (n) {
      state.unisexOk = n !== 0;
    });
  }
  var STYLE_CANDIDATES = {
    "Knee High": ["Knee High", "Knee Highs"], "Thigh High": ["Thigh High"],
    /* Pantyhose synonyms incl. Waist High variants — active maternity products carry
       "Maternity Waist High" (pantyhose = waist high vocab drift, found 2026-07-20) */
    "Pantyhose": ["Pantyhose", "Maternity Pantyhose", "Maternity Waist High", "Waist High"],
    "Crew": ["Crew Length", "Mini-Crew/Anklet"]
  };
  state.styleValues = {}; /* per-base resolved live value subsets (same Shopify quirk as Unisex) */
  function buildUrl(o) {
    o = o || {};
    var pair = state.unisexOk === false ? [] : ['Unisex'];
    /* "No preference" (gender === 'any') applies NO gender filter — widest set (Women's/Men's/Unisex). A gendered pick still adds Unisex alongside. */
    var genderMap = { "Women's": ["Women's"].concat(pair), "Men's": ["Men's"].concat(pair), "Unisex": ["Unisex"] };
    var styleMap = {};
    for (var k in STYLE_CANDIDATES) styleMap[k] = state.styleValues[k] || STYLE_CANDIDATES[k].slice(0, 1);
    var base = o.base !== undefined ? o.base : state.base;
    var level = o.level !== undefined ? o.level : state.level;
    var gender = o.gender !== undefined ? o.gender : state.gender;
    var style = o.style !== undefined ? o.style : state.style;
    var toe = o.toe !== undefined ? o.toe : state.toe;
    var params = [];
    var add = function (key, arr) { (arr || []).forEach(function (v) {
      params.push('filter.p.m.custom.' + key + '=' + encodeURIComponent(v)); }); };
    if (gender && gender !== 'any') add('filter_gender', genderMap[gender]);
    if (level !== null && level !== undefined) add('filter_compression', [window.CS_LEVELS[level].facet]);
    if (style && styleMap[style]) add('filter_style_length', styleMap[style]); /* v2.4: athletic exclusion removed — sport products carry style_length now */
    if (toe) add('filter_toe_type', [toe]);
    return base + (params.length ? '?' + params.join('&') : '');
  }
  function setOff(el, off, n) {
    el.classList.toggle('pf2-off', off);
    el.disabled = !!off;
    var tag = el.querySelector('.pf2-none');
    if (off && !tag) { tag = document.createElement('span'); tag.className = 'pf2-none'; tag.textContent = 'None available for your selections'; el.appendChild(tag); }
    if (!off && tag) tag.remove();
  }

  /* ---------- breadcrumb chips ---------- */
  function setCrumb(step, label) {
    var i = crumbs.findIndex(function (c) { return c.step === step; });
    if (i >= 0) crumbs.splice(i, crumbs.length - i);
    crumbs.push({ step: step, label: label });
    renderCrumbs();
  }
  function dropCrumbsAfter(step) {
    var order = ['why', 'condition', 'level', 'gender'];
    var k = order.indexOf(step);
    crumbs = crumbs.filter(function (c) { return order.indexOf(c.step) < k; });
    renderCrumbs();
  }
  function renderCrumbs() {
    var el = root.querySelector('.pf2-crumbs');
    if (!el) return;
    el.innerHTML = crumbs.map(function (c) {
      return '<button type="button" class="pf2-crumb" data-step="' + c.step + '" aria-label="Edit answer: ' + escapeHtml(c.label) + '">' + escapeHtml(c.label) + ' <span aria-hidden="true">&#9998;</span></button>';
    }).join('<span class="pf2-crumb-sep">&rsaquo;</span>');
    el.style.display = crumbs.length ? 'flex' : 'none';
    el.querySelectorAll('.pf2-crumb').forEach(function (b) {
      b.addEventListener('click', function () {
        var s = b.dataset.step;
        dropCrumbsAfter(s);
        if (s === 'why') { state.base = '/collections/all'; state.gender = null; state.style = null; state.toe = null; state.conditionPath = false; }
        if (s === 'gender') { state.style = null; state.toe = null; }
        go(s);
      });
    });
  }

  function activeFlow() {
    return state.conditionPath
      ? ['why', 'condition', 'level', 'gender', 'style']
      : ['why', 'level', 'gender', 'style'];
  }

  function focusCurrentStep(step) {
    var heading = step && step.querySelector('.pf2-q');
    if (!heading) return;
    window.requestAnimationFrame(function () {
      heading.focus({ preventScroll: true });
      heading.scrollIntoView({
        block: 'start',
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    });
  }

  function show(i, moveFocus) {
    current = i;
    steps.forEach(function (s, j) { s.classList.toggle('pf2-on', j === i); });
    var name = steps[i].dataset.step;
    var flow = activeFlow();
    var total = flow.length;
    var disp = Math.max(1, flow.indexOf(name) + 1);
    var pct = Math.round((disp / total) * 100);
    var countText = 'Question ' + disp + ' of ' + total + ' · ' + pct + '% complete';
    root.querySelector('.pf2-fill').style.width = pct + '%';
    root.querySelector('.pf2-count').textContent = countText;
    var progress = root.querySelector('.pf2-bar');
    progress.setAttribute('aria-valuemax', total);
    progress.setAttribute('aria-valuenow', disp);
    progress.setAttribute('aria-valuetext', 'Question ' + disp + ' of ' + total);
    root.querySelector('.pf2-back').style.visibility = name !== 'why' ? 'visible' : 'hidden';
    if (name === 'level') renderLevel();
    if (name === 'style') checkStyles();
    if (name === 'gender') {
      root.querySelectorAll('[data-gender]').forEach(function (c) {
        var lock = !!state.genderLock && c.dataset.gender !== "Women's";
        c.classList.toggle('pf2-off', lock);
        c.disabled = lock;
        c.title = lock ? 'Maternity styles are fitted for women' : '';
      });
    }
    if (moveFocus) focusCurrentStep(steps[i]);
  }
  function go(name, moveFocus) {
    for (var i = 0; i < steps.length; i++) if (steps[i].dataset.step === name) return show(i, moveFocus !== false);
  }

  /* step 1: why */
  root.querySelectorAll('[data-why]').forEach(function (c) {
    c.addEventListener('click', function () {
      var w = c.dataset.why;
      state.base = '/collections/all'; state.style = null; state.toe = null;
      state.conditionPath = (w === 'condition'); state.relaxed = [];
      state.allowed = c.dataset.allow ? c.dataset.allow.split(',').map(Number) : null; /* ticket 86e2b4z64: per-path level gating */
      state.genderLock = (w === 'pregnancy'); /* pregnancy: Women's only */
      state.levelZero = {}; /* v2.4: reset cached zero-availability when path changes */
      var lw1 = root.querySelector('.pf2-levels'); if (lw1) lw1.dataset.checkedBase = ''; /* force probes to re-run */
      setCrumb('why', c.querySelector('b').textContent);
      if (w === 'travel') { state.level = 1; recLevel = 1; probeUnisex(); go('level'); }
      else if (w === 'pregnancy') { state.base = '/collections/maternity'; state.level = 1; recLevel = 1; probeUnisex(); go('level'); }
      else if (w === 'condition') { go('condition'); }
      else if (w === 'sport') { state.base = '/collections/athletic-socks'; state.level = 1; recLevel = 1; probeUnisex(); go('level'); }
    });
  });
  root.querySelectorAll('[data-cond]').forEach(function (c) {
    c.addEventListener('click', function () {
      state.base = c.dataset.cond;
      state.conditionPath = true; state.relaxed = [];
      state.level = parseInt(c.dataset.lvl || '2', 10);
      recLevel = state.level;
      state.allowed = c.dataset.allow ? c.dataset.allow.split(',').map(Number) : null;
      state.genderLock = false;
      state.levelZero = {};
      var lw2 = root.querySelector('.pf2-levels'); if (lw2) lw2.dataset.checkedBase = '';
      setCrumb('condition', c.querySelector('b').textContent);
      probeUnisex();
      go('level');
    });
  });

  /* step 2: level — with availability when base is narrowed */
  function renderLevel() {
    var wrap = root.querySelector('.pf2-levels');
    if (!wrap.dataset.built) {
      wrap.dataset.built = '1';
      wrap.innerHTML = window.CS_LEVELS.map(function (l, i) {
        return '<button type="button" class="pf2-pill" data-i="' + i + '">' + l.label + '</button>';
      }).join('');
      wrap.querySelectorAll('.pf2-pill').forEach(function (p) {
        p.addEventListener('click', function () { if (!p.disabled) { state.level = parseInt(p.dataset.i, 10); renderLevel(); } });
      });
      root.querySelector('.pf2-level-next').addEventListener('click', function () {
        setCrumb('level', window.CS_LEVELS[state.level].label);
        go('gender');
      });
    }
    var l = window.CS_LEVELS[state.level];
    /* v2.4: combine data-allow gating with CACHED zero-availability so re-renders
       (e.g. tapping another level) can't re-enable a level with no products */
    var levelOff = function (idx) {
      if (state.allowed && state.allowed.indexOf(idx) < 0) return 'Not suitable for this selection';
      if (state.levelZero && state.levelZero[idx]) return 'None available for this selection';
      return '';
    };
    wrap.querySelectorAll('.pf2-pill').forEach(function (p, i) {
      p.setAttribute('aria-pressed', i === state.level ? 'true' : 'false');
      p.innerHTML = window.CS_LEVELS[i].label + (i === recLevel ? ' <span class="pf2-rec">Suggested</span>' : '');
      var why = levelOff(i);
      p.classList.toggle('pf2-off', !!why);
      p.disabled = !!why;
      p.title = why;
    });
    if (levelOff(state.level)) {
      for (var a = 0; a < window.CS_LEVELS.length; a++) { if (!levelOff(a)) { state.level = a; return renderLevel(); } }
    }
    root.querySelector('.pf2-lname').textContent = l.label + ' — ' + l.name.split('—').pop().trim();
    root.querySelector('.pf2-ldesc').textContent = l.desc;
    root.querySelector('.pf2-lrx').style.display = l.rx ? 'block' : 'none';
    var bands = root.querySelector('.pf2-bands'), h = '';
    for (var i = 0; i < 8; i++) { var y = 92 - i * 11, t = i / 7, o = 0.15 + (1 - t) * l.k * 0.8;
      h += '<rect x="' + (12 + t * 4) + '" y="' + (y - 9) + '" width="' + (32 - t * 6) + '" height="9" rx="2" fill="#0057B8" opacity="' + o.toFixed(2) + '"/>'; }
    bands.innerHTML = h;
    if (state.base !== '/collections/all' && (!wrap.dataset.checkedBase || wrap.dataset.checkedBase !== state.base)) {
      wrap.dataset.checkedBase = state.base;
      var tok = ++availToken;
      window.CS_LEVELS.forEach(function (lv, i) {
        countFor(buildUrl({ level: i, gender: null, style: null, toe: null })).then(function (n) {
          if (tok !== availToken) return;
          var p = wrap.querySelectorAll('.pf2-pill')[i];
          state.levelZero = state.levelZero || {};
          state.levelZero[i] = (n === 0);
          var offA = !!(state.allowed && state.allowed.indexOf(i) < 0);
          if (p) { p.classList.toggle('pf2-off', n === 0 || offA); p.disabled = n === 0 || offA; p.title = n === 0 ? 'None available for this selection' : (offA ? 'Not suitable for this selection' : ''); }
          if (n === 0 && state.level === i) { /* auto-move to first enabled */
            for (var j = 0; j < window.CS_LEVELS.length; j++) {
              var q = wrap.querySelectorAll('.pf2-pill')[j];
              if (q && !q.disabled && countCache[buildUrl({ level: j, gender: null, style: null, toe: null })] !== 0) { state.level = j; renderLevel(); break; }
            }
          }
        });
      });
    }
  }

  /* step 3: who for */
  root.querySelectorAll('[data-gender]').forEach(function (c) {
    c.addEventListener('click', function () {
      state.gender = c.dataset.gender;
      setCrumb('gender', c.querySelector('b').textContent);
      go('style');
    });
  });

  /* step 4: style + toe — availability-checked */
  function checkStyles() {
    var tok = ++availToken;
    var goBtn = root.querySelector('.pf2-go');
    goBtn.disabled = !state.style;
    goBtn.textContent = 'See my products →';
    var jobs = [];
    root.querySelectorAll('[data-style]').forEach(function (c) {
      var style = c.dataset.style;
      var cands = STYLE_CANDIDATES[style] || [style];
      jobs.push(Promise.all(cands.map(function (v) {
        state.styleValues[style] = [v];
        var u = buildUrl({ style: style, toe: null });
        delete state.styleValues[style];
        return countFor(u);
      })).then(function (ns) {
        if (tok !== availToken) return;
        var live = cands.filter(function (v, i) { return ns[i] !== 0; });
        state.styleValues[style] = live.length ? live : cands.slice(0, 1);
        var total = ns.reduce(function (a, n) { return a + (n > 0 ? n : 0); }, 0);
        var unknown = ns.some(function (n) { return n === -1; });
        setOff(c, total === 0 && !unknown);
        if (total === 0 && !unknown && state.style === style) {
          state.style = null;
          c.classList.remove('pf2-sel');
          c.setAttribute('aria-pressed', 'false');
          goBtn.disabled = true;
        }
      }));
    });
    /* never dead-end: if every style is unavailable, allow a style-less submit
       (final pre-flight relax chain already handles routing) */
    Promise.all(jobs).then(function () {
      if (tok !== availToken) return;
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-style]'));
      if (cards.length && cards.every(function (c) { return c.disabled; })) {
        state.style = null; state.toe = null;
        goBtn.disabled = false;
        goBtn.textContent = 'See all matching products →';
      }
    });
  }
  function checkToes() {
    var tok = availToken;
    root.querySelectorAll('[data-toe]').forEach(function (b) {
      countFor(buildUrl({ toe: b.dataset.toe })).then(function (n) {
        if (tok !== availToken) return;
        b.classList.toggle('pf2-off', n === 0);
        b.disabled = n === 0;
        if (n === 0 && state.toe === b.dataset.toe) { state.toe = null; b.setAttribute('aria-pressed', 'false'); }
      });
    });
  }
  root.querySelectorAll('[data-style]').forEach(function (c) {
    c.addEventListener('click', function () {
      if (c.disabled) return;
      state.style = c.dataset.style; state.toe = null;
      root.querySelectorAll('[data-style]').forEach(function (x) {
        var selected = x === c;
        x.classList.toggle('pf2-sel', selected);
        x.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      root.querySelectorAll('[data-toe]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      var toeWrap = root.querySelector('.pf2-toe');
      toeWrap.style.display = (state.style === 'Pantyhose') ? 'none' : 'flex';
      root.querySelector('.pf2-go').disabled = false;
      checkToes();
    });
  });
  root.querySelectorAll('[data-toe]').forEach(function (c) {
    c.addEventListener('click', function () {
      if (c.disabled) return;
      state.toe = c.dataset.toe === state.toe ? null : c.dataset.toe;
      root.querySelectorAll('[data-toe]').forEach(function (x) { x.setAttribute('aria-pressed', x.dataset.toe === state.toe ? 'true' : 'false'); });
    });
  });

  /* ---------- results summary + navigation ---------- */
  function summary() {
    var lv = window.CS_LEVELS[state.level] || {};
    var byStep = {};
    crumbs.forEach(function (c) { byStep[c.step] = c.label; });
    return {
      why: byStep.why || null,
      condition: byStep.condition || null,
      level: lv.label || null,
      rx: !!lv.rx,
      gender: state.gender ? (byStep.gender || null) : null,
      style: state.style,
      toe: state.toe,
      relaxed: state.relaxed || [],
      ts: Date.now(),
      m: { base: state.base, level: state.level, rec: recLevel, allowed: state.allowed, lock: !!state.genderLock, gender: state.gender, style: state.style, toe: state.toe, conditionPath: !!state.conditionPath }
    };
  }
  function navigate(url) {
    try { sessionStorage.setItem('cs_pf', JSON.stringify(summary())); } catch (e) {}
    window.location.href = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'pf=1';
  }
  function finish(url) {
    var btn = root.querySelector('.pf2-go');
    btn.disabled = false; btn.textContent = 'See my products →';
    root.removeAttribute('aria-busy');
    navigate(url);
  }

  /* Never land on an empty page. If a preference must be broadened, update the
     saved summary so the results page explains exactly what changed. */
  root.querySelector('.pf2-go').addEventListener('click', function () {
    var btn = this; btn.disabled = true; btn.textContent = 'Checking availability…';
    root.setAttribute('aria-busy', 'true');
    var attempts = [
      { url: buildUrl({}), relax: [] },
      { url: buildUrl({ toe: null }), relax: ['toe preference'] },
      { url: buildUrl({ toe: null, style: null }), relax: ['toe preference', 'style'] },
      { url: buildUrl({ toe: null, style: null, level: null }), relax: ['toe preference', 'style', 'compression level'] },
      { url: buildUrl({ toe: null, style: null, level: null, gender: null }), relax: ['toe preference', 'style', 'compression level', 'who it is for'] }
    ];
    function applyRelaxation(items) {
      state.relaxed = items.slice();
      if (items.indexOf('toe preference') >= 0) state.toe = null;
      if (items.indexOf('style') >= 0) state.style = null;
      if (items.indexOf('compression level') >= 0) state.level = null;
      if (items.indexOf('who it is for') >= 0) state.gender = null;
    }
    (function tryNext(i) {
      if (i >= attempts.length) {
        applyRelaxation(attempts[attempts.length - 1].relax);
        finish(attempts[attempts.length - 1].url);
        return;
      }
      countFor(attempts[i].url).then(function (n) {
        if (n === 0) tryNext(i + 1);
        else {
          applyRelaxation(attempts[i].relax);
          finish(attempts[i].url);
        }
      });
    })(0);
  });

  /* Path-aware Back keeps the answer chips and question count in sync. */
  function prevStepName() {
    var name = steps[current].dataset.step;
    if (name === 'style') return 'gender';
    if (name === 'gender') return 'level';
    if (name === 'level') return state.conditionPath ? 'condition' : 'why';
    return 'why';
  }
  root.querySelector('.pf2-back').addEventListener('click', function () {
    var t = prevStepName();
    if (t === 'why') {
      dropCrumbsAfter('why');
      state.base = '/collections/all'; state.gender = null; state.style = null; state.toe = null;
      state.allowed = null; state.genderLock = false; state.levelZero = {}; state.conditionPath = false; state.relaxed = [];
    } else if (t === 'condition' || t === 'level' || t === 'gender') {
      dropCrumbsAfter(t);
    }
    go(t);
  });

  /* "Edit answers" restore — /pages/product-finder#edit re-hydrates the last run
     from sessionStorage (1h TTL) and jumps to the style step with crumbs intact. */
  var restored = false;
  try {
    if (window.location.hash === '#edit') {
      var saved = JSON.parse(sessionStorage.getItem('cs_pf') || 'null');
      if (saved && saved.ts && Date.now() - saved.ts < 3600000 && saved.m) {
        var m = saved.m;
        state.base = m.base || '/collections/all';
        state.level = (typeof m.level === 'number') ? m.level : 1;
        recLevel = (typeof m.rec === 'number') ? m.rec : state.level;
        state.allowed = m.allowed || null;
        state.genderLock = !!m.lock;
        state.gender = m.gender || null;
        state.style = m.style || null;
        state.toe = m.toe || null;
        state.conditionPath = !!m.conditionPath || !!saved.condition;
        state.relaxed = saved.relaxed || [];
        state.levelZero = {};
        probeUnisex();
        crumbs = [];
        if (saved.why) crumbs.push({ step: 'why', label: saved.why });
        if (saved.condition) crumbs.push({ step: 'condition', label: saved.condition });
        if (saved.level) crumbs.push({ step: 'level', label: saved.level });
        if (saved.gender) crumbs.push({ step: 'gender', label: saved.gender });
        renderCrumbs();
        root.querySelectorAll('[data-style]').forEach(function (x) {
          var selected = x.dataset.style === state.style;
          x.classList.toggle('pf2-sel', selected);
          x.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        root.querySelectorAll('[data-toe]').forEach(function (x) { x.setAttribute('aria-pressed', x.dataset.toe === state.toe ? 'true' : 'false'); });
        if (state.style) {
          root.querySelector('.pf2-go').disabled = false;
          root.querySelector('.pf2-toe').style.display = state.style === 'Pantyhose' ? 'none' : 'flex';
        }
        go('style');
        restored = true;
      }
    }
  } catch (e) {}
  if (!restored) show(0, false);
})();
